import React from "react";

function Footer(props) {
  return (
    <footer
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f8f9fa",
        height: 50,
      }}
    >
      <span>&copy; Synthesys 2021. All rights reserved!</span>
    </footer>
  );
}

export default Footer;
